/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ArrayOfByte } from '../arrayOfByte.schema';

export const SscrSiteAssignmentSummaryDto = zod.object({
  "id": zod.string().uuid().optional(),
  "changeRequestId": zod.string().uuid().optional(),
  "monthlyCoveragePlanId": zod.string().uuid().optional(),
  "monthId": zod.number().optional(),
  "monthName": zod.string().optional(),
  "year": zod.number().optional(),
  "coordinatorId": zod.string().uuid().optional(),
  "coordinatorName": zod.string().optional(),
  "areaId": zod.number().optional(),
  "areaName": zod.string().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "timestamp": zod.lazy(() => ArrayOfByte).optional(),
  "dateFrom": zod.coerce.date().optional(),
  "dateTo": zod.coerce.date().optional()
});

export type SscrSiteAssignmentSummaryDto = zod.input<typeof SscrSiteAssignmentSummaryDto>;
export type SscrSiteAssignmentSummaryDtoOutput = zod.output<typeof SscrSiteAssignmentSummaryDto>;
